import styled from 'styled-components';
import ToiletPaperSvg from '../../assets/amenities/toilet-paper.svg';

const ToiletPaperIcon = styled(ToiletPaperSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default ToiletPaperIcon;
